module.exports = __webpack_public_path__ + "static/media/black-plus.72fd2bb5.svg";